// src/socket.js
import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_SOCKET_SERVER, {
  transports: ["websocket"],
});

socket.on("connect", () => {
  // console.log("✅ Socket.IO connected:", socket.id);
});

export default socket;
